import { FSMCommonTransitions } from '../../../../../FSM/shared/constants'

const FSMTransitionsFNOLVehicleNO = {
  ...FSMCommonTransitions,
  FLOW_MACHINE_ID: 'FNOLFlowMachineVehicleNO',
}

export { FSMTransitionsFNOLVehicleNO }
